import {Component, HostListener, OnInit} from '@angular/core';
import {HistoryItem} from '../../directory-item/activity/history-item.class';
import {ApiClientService} from '../../../services/api-client.service';
import {PassOnLogService} from '../../../services/pass-on-log.service';
import {PassOnLog} from '../../../types/data.types';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'pass-on-log-history',
    templateUrl: './pass-on-log-history.component.html',
    styleUrls: ['./pass-on-log-history.component.scss']
})
export class PassOnLogHistoryComponent implements OnInit {
    showModal = false;
    activities: HistoryItem[] = [];
    data: PassOnLog;
    loadingHistory = true;

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public passOnLogService: PassOnLogService
    ) {}

    ngOnInit() {
        this.initData();
        this.data = this.passOnLogService.passOnLogInHistoryModal;
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.getActivityParcels();
    }

    hideModal() {
        this.passOnLogService.isPassOnLogHistoryModalShow = false;
        this.passOnLogService.passOnLogInHistoryModal = null;
        this.urlService.modalClosed.emit();
    }

    getActivityParcels() {
        const url = `/v1/history.json?per-page=10000&order-by=loggedAt|desc&objectId=${this.passOnLogService.passOnLogInHistoryModal.id}`;
        this.passOnLogService.api.get('domainPassOnLog', url).subscribe(
            res   => {
                this.loadingHistory = false;
                this.activities = res.json().map(a => new HistoryItem(a));
            },
            error => this.passOnLogService.api.errorHandler(error, 'Failed get Parcels')
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-history/pass-on-log-history.component.ts